/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const CouponCreatePage = lazyLoad(
  () => import('./index'),
  module => module.CouponCreatePage
);
